module.exports = __webpack_public_path__ + "static/media/br-mg.521cb808.svg";